
<div class="modal-header">
    <h4>Informe de resolución mensual</h4>
</div>
<div class="modal-body">
    <pdf-viewer [src]="pdfSrc"
    [render-text]="true"
    [original-size]="false"
    style="width: 1100px; height: 45em"
></pdf-viewer>
</div>
<div class="modal-footer">
    <br>
    <button (click)="descargarPdf()" class="btn btn-primary">Descargar PDF</button>
    <button (click)="this.activeModal.dismissAll()" class="btn btn-secondary">Cerrar</button>
    <br>
</div>